<template>
  <a
    v-if="downloadUrl"
    :href="downloadUrl || undefined"
    :target="target || undefined"
    download
    class="brochure-tile-fi"
    @click="handleDownload"
  >
    <div class="brochure-tile-fi__image-container">
      <cloud-image-fi
        v-if="thumbnailUrl"
        class="brochure-tile-fi__image"
        :src="thumbnailUrl"
        :alt="title"
        params="func=fit&bg_img_fit=1&bg_opacity=0.7&bg_colourise=black&bg_blur=100&fit_enlarge=1"
      />
    </div>
    <div class="brochure-tile-fi__content">
      <icon-fi
        class="brochure-tile-fi__file-download-icon"
        icon="download"
      />
      <div
        v-if="title"
        class="brochure-tile-fi__headline"
      >
        {{ title }}
      </div>
      <p
        v-if="previewText"
        class="brochure-tile-fi__preview-text"
      >
        {{ previewText }}
      </p>
    </div>
  </a>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

import CloudImageFi from '@/components/atoms/cloud-image-fi/CloudImageFi.vue';
import { useEventHub } from '@/composables/eventHub';

defineOptions({ name: 'BrochureTileFi' });

interface Props {
  title?: string;
  previewText?: string;
  downloadUrl?: string;
  thumbnailUrl?: string;
  target?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  previewText: '',
  downloadUrl: '',
  thumbnailUrl: '',
  target: null,
});

const { sendEvent } = useEventHub();

const handleDownload = () => {
  sendEvent('custom', {}, 'download', {
    link: props.downloadUrl,
    name: props.title,
  });
};
</script>

<style scoped src="./brochure-tile-fi" />
